import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'
import { PROJECTED_NEXT_12_MONTHS } from '../Constants'
export type MonthAndYearType = {
  month?: number
  year?: number
}
export type CustomDateRangeType = { startDate: MonthAndYearType; endDate: MonthAndYearType }
type IncomesFilter = {
  period?: number
  projectedPeriod?: string
  historicalDateRange?: string
  type?: boolean
  prev?: string
  accountHistoricalPeriod?: string
  years?: string
  page?: string
}
interface IIncomeSliceState {
  incomesFilter: IncomesFilter
  incomeDetailOptionPremiumValue?: boolean
  showOptionPremiumCheckbox?: boolean
  accountCustomDateRange?: CustomDateRangeType
  summaryCustomDateRange?: CustomDateRangeType
}

const initialState: IIncomeSliceState = {
  incomesFilter: {
    projectedPeriod: PROJECTED_NEXT_12_MONTHS,
    historicalDateRange: new Date().getFullYear().toString(),
    type: true,
    accountHistoricalPeriod: new Date().getFullYear().toString(),
    page: 'summary'
  },
  incomeDetailOptionPremiumValue: false,
  showOptionPremiumCheckbox: false
}

const Slice = createSlice({
  name: '@module/accounts/incomes',
  initialState,
  reducers: {
    SetIncomesFilter: (state, action: PayloadAction<IncomesFilter>) => {
      return { ...state, incomesFilter: { ...action.payload } }
    },
    SetAccountCustomDateRange: (state, action: PayloadAction<CustomDateRangeType>) => {
      return { ...state, accountCustomDateRange: { ...action.payload } }
    },
    SetSummaryCustomDateRange: (state, action: PayloadAction<CustomDateRangeType>) => {
      return { ...state, summaryCustomDateRange: { ...action.payload } }
    },
    SetIncomeDetailOptionPremiumCheckboxValue: (state, action: PayloadAction<boolean>) => {
      return { ...state, incomeDetailOptionPremiumValue: action.payload }
    },
    SetShowIncomeDetailOptionPremiumCheckbox: (state, action: PayloadAction<boolean>) => {
      return { ...state, showOptionPremiumCheckbox: action.payload }
    }
  }
})

export const {
  SetIncomesFilter,
  SetIncomeDetailOptionPremiumCheckboxValue,
  SetShowIncomeDetailOptionPremiumCheckbox,
  SetAccountCustomDateRange,
  SetSummaryCustomDateRange
} = Slice.actions
export const getIncomeDetailOptionPremiumCheckboxValue = (state: RootState) =>
  state.modules.accounts.incomes.incomeDetailOptionPremiumValue
export const getIncomesFilterState = (state: RootState) => state.modules.accounts.incomes.incomesFilter
export const getAccountCustomDateRangeState = (state: RootState) =>
  state.modules.accounts.incomes.accountCustomDateRange
export const getSummaryCustomDateRangeState = (state: RootState) =>
  state.modules.accounts.incomes.summaryCustomDateRange
export const getShowIncomeDetailOptionPremiumCheckbox = (state: RootState) =>
  state.modules.accounts.incomes.showOptionPremiumCheckbox
export default Slice.reducer
